import { useTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { i18n as i18nType } from 'i18next';
import { useEffect } from 'react';
import { ChangeLanguageType, requestChangeLanguage, selectLanguage } from '../../store/app';
import { useCookies } from 'react-cookie';

type ChangeLanguageHookFunctionType = (
  i18n: i18nType,
  changeLanguageAction: ChangeLanguageType,
) => (value: string) => void;

export const changeLanguage: ChangeLanguageHookFunctionType = (i18n, changeLanguageAction) => (
  value,
) => {
  changeLanguageAction(i18n, value);
};

export const useLanguage = () => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const [, setCookie] = useCookies(['PartnerLang']);

  const changeLanguageAction = bindActionCreators(requestChangeLanguage, dispatch);
  const currentLanguage = useSelector(selectLanguage);
  /*
    we cache the language the user choose on the reducer
    on component mount this effect will check if the currentLanguage
    stored in the reducer (cached) matches the language set by i18n
    and if they are different it will fire the [changeLanguageAction] so that
    we always maintain them synced
  */
  useEffect(() => {
    if (currentLanguage !== i18n.language) {
      changeLanguageAction(i18n, currentLanguage || i18n.language);
    }
  }, [currentLanguage]);

  const setLanguage = (lang: string) => {
    setCookie('PartnerLang', lang, { path: '/' });
    changeLanguage(i18n, changeLanguageAction)(lang);
  };
  return {
    onLanguageChange: setLanguage,
    currentLanguage,
    t,
    i18n,
  };
};
